import React, { PropTypes } from 'react';
import moment from 'moment';

const Simulation = ({ data, invoiceDate, interventionStartDate }) => {
  const renderIntervalInvoiceWarning = () => {
    const interventionMoment = moment(invoiceDate, 'DD/MM/YYYY');
    if (
      !interventionMoment.isBetween(
        data.start_date,
        data.end_date,
        'day',
        '[]'
      ) &&
      data.invoice_number
    ) {
      return (
        <p style={{ 'padding-top': '10px' }}>
          <i className="warning sign yellow icon" />
          <strong>Attention:</strong> la date de facturation n'est pas incluse
          dans la durée du contrat
        </p>
      );
    }
  };

  const renderIntervalInterventionWarning = () => {
    const interventionMoment = moment(interventionStartDate, 'DD/MM/YYYY');
    if (
      !interventionMoment.isBetween(data.start_date, data.end_date, 'day', '[]')
    ) {
      return (
        <p style={{ 'padding-top': '10px' }}>
          <i className="warning sign yellow icon" />
          <strong>Attention:</strong> la date de forçage de première
          intervention est ignorée car elle n'est pas incluse dans la durée du
          contrat
        </p>
      );
    }
  };

  const invoiceFrequency = ({ invoice_by_intervention, invoice_number }) => {
    if (invoice_by_intervention === true) {
      return 'à la validation des interventions';
    } else {
      return invoice_number;
    }
  };

  const dateFormat = (date, emptyVal) => {
    if (date) {
      return moment(date).format('DD/MM/YYYY');
    } else {
      return emptyVal;
    }
  };

  return (
    <div className="ui segment teal lighten">
      <h4>Dates d'organisation</h4>
      <div className="ui grid">
        <div className="five wide column">
          <p>
            <strong>Date de début</strong>: {dateFormat(data.start_date, '')}
          </p>
        </div>
        <div className="five wide column">
          <p>
            <strong>Date de fin</strong>: {dateFormat(data.end_date, '')}
          </p>
        </div>
        <div className="six wide column">
          <p>
            <strong>Date de réorganisation</strong>:{' '}
            {dateFormat(data.reorg_date, 'Pas de réorganisation')}
          </p>
        </div>
      </div>
      <div className="ui divider" />
      <h4>Nombre d'éléments générés</h4>
      <div className="ui grid">
        <div className="four wide column">
          <p>
            <strong>Interventions</strong>: {data.intervention_number}
          </p>
        </div>
        <div className="four wide column">
          <p>
            <strong>Factures</strong>: {invoiceFrequency(data)}
          </p>
        </div>
      </div>
      <div className="eight wide column">{renderIntervalInvoiceWarning()}</div>
      <div className="eight wide column">
        {renderIntervalInterventionWarning()}
      </div>
    </div>
  );
};

Simulation.propTypes = {
  data: PropTypes.object.isRequired,
  invoiceDate: PropTypes.string.isRequired,
  interventionStartDate: PropTypes.string.isRequired,
};

export default Simulation;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/organize/Simulation.js